import Vue from 'vue'

import 'normalize.css/normalize.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'

import '@/styles/index.scss'
import '@/styles/table.scss'

import App from './App'
import store from './store'
import router from './router'
import VueI18n from 'vue-i18n'
import { en } from '@/assets/lang/en'

import '@/icons'
import '@/permission'

Vue.use(ElementUI, { locale })
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  messages: { 'en': en }
})

Vue.config.productionTip = false

Vue.filter('DateTimeZH', function(value) {
  if (value != null) {
    const d = new Date()
    d.setTime(Date.parse(value))
    value = d.getFullYear() + '-' + d.getMonth() + 1 + '-' + d.getDate()
    return value
  } else {
    return ''
  }
})

Vue.filter('StateZH', function(value) {
  if (value != null) {
    if (value === 1) {
      return '已入库'
    } else if (value === 2) {
      return '已出库生产'
    } else {
      return ''
    }
  } else {
    return ''
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js